import { delay } from 'lodash';
import VirtualPageManager from 'navigation/page-manager/VirtualPageManager';
import { State } from 'helpers/state';
import InternalRouter from 'navigation/pages/InternalRouter';
import PanelPage from 'navigation/pages/PanelPage';
import store from 'store';
import EditorialRelatedContent from 'components/editorial-related-content/EditorialRelatedContent';
import Footer from 'components/footer/Footer';
import { bindMethod } from 'helpers/bind';
import CheckoutPage from 'navigation/pages/CheckoutPage';
import AdaptableWrapper from 'components/adaptable-wrapper/AdaptableWrapper';
import CheckoutBreadcrumb from './partials/CheckoutBreadcrumb';
import CheckoutPopin from './partials/CheckoutPopin';
import CheckoutSummary from './partials/CheckoutSummary';
class Checkout extends InternalRouter {
    initialized() {
        super.initialized();
        this.testStep(this.el);
    }
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            popin: ['.checkout-popin', CheckoutPopin],
            summaryItem: ['.checkout__summary:not([default-route]) > *', CheckoutSummary],
            breadcrumb: ['.checkout-breadcrumb', CheckoutBreadcrumb],
            editorialRelatedContent: ['.editorial-related-content', EditorialRelatedContent],
            adaptableWrapper: ['.adaptable-wrapper', AdaptableWrapper],
            footer: ['footer', Footer]
        };
    }
    async preload(previousPage) {
        if (!this.modules.summary)
            return super.preload();
        return Promise.all([
            super.preload(),
            new Promise(resolve => this.modules.summary.once('loaded', resolve))
        ]);
    }
    bindModules() {
        super.bindModules();
        if (this.refs.checkoutSummary.hasAttribute('default-route')) {
            if (!this.modules.summary)
                this.modules.summary = this.initSummaryRouter();
        }
        else if (this.modules.summaryItem) {
            const { summaryItem } = this.modules;
            summaryItem.askPreload().then(() => summaryItem.askShow());
        }
    }
    openPopin(url) {
        this.modules.popin.store.set(url);
    }
    initSummaryRouter() {
        return new VirtualPageManager(new State(null), this.refs.checkoutSummary, '.page', PanelPage);
    }
    getPageSelector() {
        return '.checkout__step';
    }
    getDefaultPageClass() {
        return CheckoutPage;
    }
    shouldRouteInternally(el) {
        if (this.step >= 5)
            return false;
        const page = el.querySelector(this.getPageSelector());
        if (!page)
            return false;
        const step = page.getAttribute('data-step');
        if (step)
            return (+step) < 5;
    }
    testStep(el) {
        const page = el.querySelector(this.getPageSelector());
        if (!page)
            return;
        const step = page.getAttribute('data-step');
        if (step) {
            this.step = +step;
            store.checkoutStep.set(+step);
        }
    }
    bindEvents(add = true) {
        super.bindEvents(...arguments);
        const { summary } = this.modules;
        const method = bindMethod(add);
        summary && summary[add ? 'on' : 'off']('virtual', this.onSummaryUpdate);
        this.refs.summaryButton[method]('click', this.onSummaryButtonClick);
    }
    onSummaryButtonClick = () => {
        store.checkoutSummaryOpened.set(!store.checkoutSummaryOpened.get());
    };
    async internalRouting(pathName, xhr, requestOptions = {}) {
        this.testStep(xhr.response);
        this.modules.content.forceRouteUpdate(pathName, xhr, requestOptions);
        const { summary } = this.modules;
        const refresh = () => summary && summary.refresh();
        const container = this.refs.checkoutSummary;
        if (container.classList.contains('opened')) {
            this.refs.checkoutSummary.classList.remove('opened');
            delay(refresh, 400);
        }
        else {
            refresh();
        }
    }
    refreshPage() {
        this.modules?.content?.refresh();
    }
    onSummaryUpdate = () => {
        const { content, summary } = this.modules;
        if (content.currentPage.pageName() === 'CheckoutPayment' && summary) {
            summary.once('show', () => {
                content.refresh();
            });
        }
    };
}
export default Checkout;
